import script from "./ShoesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoesPage.vue?vue&type=script&setup=true&lang=js"

import "./ShoesPage.vue?vue&type=style&index=0&id=2f9513fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f9513fe"]])

export default __exports__